import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import BlogPost from "../components/blogPost"
import { StaticImage } from "gatsby-plugin-image"
import { Container, Row, Card, Breadcrumb } from "react-bootstrap"
import { Link } from "gatsby"
import SocialMedia from "../components/socialMedia"

const uri = "/dutch-oven-cooking-tips/"

const DutchOvenCookingTipsPage = () => {

  const coal_headings = [
    { title: 'Temp/Oven Size', temps: [ 
      { f: '325F', c: '163C'},
      { f: '350F', c: '177C'},
      { f: '375F', c: '191C'},
      { f: '400F', c: '204C'},
      { f: '425F', c: '218C'},
      { f: '450F', c: '232C'},
     ] }
  ]

  const coals = [
    { size: '8-inch',  coals: [ { t: 10, b:  5}, {t: 11, b:  5}, {t: 11, b:  6}, {t: 12, b:  6}, {t: 13, b:  6}, {t: 14, b:   6} ] },
    { size: '10-inch', coals: [ { t: 13, b:  6}, {t: 14, b:  7}, {t: 16, b:  7}, {t: 17, b:  8}, {t: 18, b:  9}, {t: 19, b:  10} ] },
    { size: '12-inch', coals: [ { t: 16, b:  7}, {t: 17, b:  8}, {t: 18, b:  9}, {t: 19, b: 10}, {t: 21, b: 10}, {t: 22, b:  11} ] },
    { size: '14-inch', coals: [ { t: 20, b: 10}, {t: 21, b: 11}, {t: 22, b: 12}, {t: 24, b: 12}, {t: 25, b: 13}, {t: 26, b:  14} ] },
    { size: '16-inch', coals: [ { t: 25, b: 12}, {t: 26, b: 13}, {t: 27, b: 14}, {t: 28, b: 15}, {t: 29, b: 16}, {t: 30, b:  17} ] },
  ]

  return (
  <Layout pageInfo={{ pageName: "dutch-oven-cooking-tips2" }}>
    <Seo title="Dutch Oven Cooking Tips" keywords={[`recipes`, `browse`]} description="Great tips for cooking with a Dutch Oven" 
        imageSrc="/dutch-oven-600.jpg" imageWidth="600" imageHeight="431" imageAlt="Dutch Oven" url={uri} />
      <Row className="justify-content-left my-3">
        <Breadcrumb>
          <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item active>Dutch Oven Cooking Tips</Breadcrumb.Item>
        </Breadcrumb>
      </Row>
      <BlogPost title="Dutch Oven Cooking Tips">

        <Container fluid className="text-center">
          <Row className="justify-content-center d-flex flex-wrap">
        
        <p>If you are cooking over a campfire and using coals to heat your oven, then a 12 or 14 inch cast iron Dutch oven 
          with a flat top is the best option. You will be able to put coals on the top and bottom. If you are placing the Dutch oven 
          in a standard oven, then a ceramic coated Dutch oven may work better, but almost any will work. Keep reading below to learn about
          the number of coals you will need.
        </p>
        <h5><Link to="/camping-cookbook/">Also see our Camping Cookbook</Link></h5>

        <div className="d-flex justify-content-center pt-4 pb-4">
            <SocialMedia uri={"https://www.iloveitrecipes.com"+uri} position="top"/>
        </div>

        <div className="pb-4 pt-2" id="dutch-oven-tips-dutch-oven">
        <StaticImage src="../images/dutch-oven-600.jpg" alt="Dutch Oven" />
        </div>

        <p>Here are some different types of Dutch ovens:</p>
        </Row>

          <Row className="justify-content-center d-flex flex-wrap pt-4">
            <Card className="m-2 mb-3 dutch-oven-card">
              <Card.Body>
                <Card.Title className="pb-1 dutch-oven-img-title">Cast Iron Dutch Oven</Card.Title>  
                <StaticImage src="../images/cast_iron_dutch_oven2.jpg" alt="Cast Iron Dutch Oven" />
                <div className="pt-2 index-card-text">
                <Card.Text >Best for campfire cooking</Card.Text>
                </div>
              </Card.Body>
            </Card>

            <Card className="m-2 mb-3 dutch-oven-card">
              <Card.Body>
                <Card.Title className="pb-1 dutch-oven-img-title">Ceramic Coated Cast Iron Dutch Oven</Card.Title>  
                <StaticImage src="../images/ceramic_cast_iron_dutch_oven2.jpg" alt="Ceramic Coated Cast Iron Dutch Oven" />
                <div className="pt-2 index-card-text">
                <Card.Text >Works well in an oven</Card.Text>
                </div>
              </Card.Body>
            </Card>

            <Card className="m-2 mb-3 dutch-oven-card">
              <Card.Body>
                <Card.Title className="pb-1 dutch-oven-img-title">Aluminum Dutch Oven</Card.Title>  
                <StaticImage src="../images/aluminum_dutch_oven.jpg" alt="Aluminum Dutch Oven" />
                <div className="pt-2 index-card-text">
                <Card.Text >A lightweight option</Card.Text>
                </div>
              </Card.Body>
            </Card>

            <Card className="m-2 mb-3 dutch-oven-card">
              <Card.Body>
                <Card.Title className="pb-1 dutch-oven-img-title">2-in-1 Dutch Oven</Card.Title>  
                <StaticImage src="../images/dutch-oven-2-in-1b.jpg" alt="2-in-1 Dutch Oven" />
                <div className="pt-2 index-card-text">
                <Card.Text >Lid works as a pan too</Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Row>
        </Container>


        <h4 className="pt-3 pb-3"><strong>How many coals (charcoal briquettes) do I need? </strong>
        </h4>
        <p>The number of coals, also known as charcoal briquettes, you need to get the right temperature depends on many factors. 
          This is the fun part. You will need to add or remove coals and move them around to control the temperature.  Here are some 
          of the factors that will come into play:
        </p>
        <ul>
          <li>Air temperature</li>
          <li>Shade/sun</li>
          <li>Size of Dutch oven</li>
          <li>Amount of food in the oven</li>
          <li>Whether the cover is on or off. You will want it off for frying and on for baking or roasting.</li>
          <li>Type of Dutch oven. Use fewer with an aluminum Dutch oven.</li><li>How hot the coals are</li>
        </ul>
        <p>Here's a chart showing the typical number of coals you will need on the top and bottom of a cast iron 
        Dutch oven. Use fewer with an aluminum Dutch oven.
        </p>
        
        <div className="d-flex justify-content-center">
        <div id="dutch-oven-coals-xs">
        <div className="wp-block-quote"><p>Number of Charcoal Briquettes</p><p>T = Top of Dutch Oven<br />B = Bottom of Dutch Oven</p></div>
        <table className="dutch-oven-coal-table-xs mt-4 mb-4">
        { coal_headings.map( rec => (
            <tr>
              <td className="p-1 dutch-oven-coal-cell-xs">Temp/<br/>Oven Size</td>
              { rec.temps.map( temps => (
                <td className="p-1 dutch-oven-coal-cell-xs"><b>{temps.f}<br/>{temps.c}</b></td>
              ))}
            </tr>
        )) }

        { coals.map( rec => (
            <tr>
              <td className="p-1 dutch-oven-coal-cell-xs">{rec.size}</td>
              { rec.coals.map( coals => (
                <td className="p-1 dutch-oven-coal-cell-xs">T:{coals.t}<br/>B:{coals.b}</td>
              ))}
            </tr>
        )) }
        </table>
        </div>

        <div id="dutch-oven-coals-sm">
        <div className="wp-block-quote"><p>Number of Charcoal Briquettes</p><p>Top = Top of Dutch Oven<br />Bottom = Bottom of Dutch Oven</p></div>
        <table className="dutch-oven-coal-table-sm mt-4 mb-4">
        { coal_headings.map( rec => (
            <tr>
              <td className="p-1 dutch-oven-coal-cell-sm p-1">Temp/<br/>Oven Size</td>
              { rec.temps.map( temps => (
                <td className="p-1 dutch-oven-coal-cell-sm p-1"><b>{temps.f}<br/>{temps.c}</b></td>
              ))}
            </tr>
        )) }

        { coals.map( rec => (
            <tr>
              <td className="p-1 dutch-oven-coal-cell-sm p-1">{rec.size}</td>
              { rec.coals.map( coals => (
                <td className="p-1 dutch-oven-coal-cell-sm p-1">Top:{coals.t}<br/>Bottom:{coals.b}</td>
              ))}
            </tr>
        )) }
        </table>
        </div>
        </div>

    </BlogPost>
  </Layout>
)
}


export default DutchOvenCookingTipsPage

